// --- Core ---
import {useEffect} from "react";
import {findWhere} from "underscore";
// --- Material UI ---
import {Typography} from "@mui/material";
// --- SaniQ ---
import {JSONAPIReference} from "../models/Helpers";
import {ExtendedTooltip} from "shared/ComplexTooltip";
import {ModelIcon} from "shared/ModelIcon";
import {useAppDispatch, useAppSelector} from "store";
import {fetchRoles} from "../modules/system/modules/roles/actions";

interface RoleLabelProps {
  reference: JSONAPIReference<'role'>
}

const RoleLabel = ({reference}: RoleLabelProps) => {
  const dispatch = useAppDispatch();
  const hasLoaded = useAppSelector(state => state.systemContext.roles.hasLoaded);
  const isLoading = useAppSelector(state => state.systemContext.roles.isLoading);
  const roles = useAppSelector(state => state.systemContext.roles.collection);

  useEffect(() => {
    if (!hasLoaded && !isLoading) {
      dispatch(fetchRoles());
    }
  }, [dispatch, hasLoaded, isLoading]);

  const role = findWhere(roles, {id: reference.id, type: reference.type});

  if (role) {
    const {description, label, name} = role;

    return (
      <ExtendedTooltip
        avatar={<ModelIcon type="role"/>}
        title={<>{label} {!!name && "(Systemrolle)"}</>}
        label={label}
      >
        {
          !!description &&
          <Typography variant="caption">
            {description}
          </Typography>
        }
      </ExtendedTooltip>
    );
  } else {
    return null;
  }
};

export {
  RoleLabel
};
